import { Link } from "react-router-dom";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { AdminPanel } from "../../components/admin/AdminPanel";

export function TrainerSettingsPage() {
  return (
    <div>
      <AdminPageHeader title="Settings" description="Workspace setup areas for the trainer foundation." />
      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        <AdminPanel title="Business profile">
          <p className="text-sm leading-6 text-graphite/70">Brand, contact and default workspace identity.</p>
          <Link className="link mt-4 inline-block text-sm" to="/trainer/business">Open business profile</Link>
        </AdminPanel>
        <AdminPanel title="Trainer profile">
          <p className="text-sm leading-6 text-graphite/70">Your professional profile inside this workspace.</p>
          <Link className="link mt-4 inline-block text-sm" to="/trainer/profile">Open trainer profile</Link>
        </AdminPanel>
        <AdminPanel title="Team">
          <p className="text-sm leading-6 text-graphite/70">Review workspace members and their access state.</p>
          <Link className="link mt-4 inline-block text-sm" to="/trainer/team">Open team</Link>
        </AdminPanel>
      </div>
    </div>
  );
}
